/**
 * Created by Owner on 2016/8/9.
 */
import { Component } from '@angular/core';
import { AlertController, ViewController, Events, ToastController } from 'ionic-angular';
import { LotteryPage } from "../lottery/lottery";
import { LotteryService } from "../../services/lottery.services";
import { AppConfigService } from "../../services/appConfig.service";
import { AppDialog } from "../../component/appDialog";
import { TranslateService } from 'ng2-translate';

@Component({
    templateUrl: 'goPeriods.html',
    selector: 'go-periods-page',
})
export class GoPeriodsPage {
    //追号总金额
    private recordList: any = [];
    private lotteryName: string;
    private goMoney: number = 0;
    private goTraceTime: number = 0;
    private totalMoney: number = 0;
    private totalNum: number = 0;
    private isGo: boolean = true;
    goStop: boolean = true;
    private traceIssues: any = new Map([]);

    constructor(public events: Events, private alertCtrl: AlertController,
        private translate: TranslateService,
         private toastCtrl: ToastController
        , private lotteryService: LotteryService, public viewCtrl: ViewController) {
        //追号结束
        this.events.subscribe('issues:goOver', () => {
            this.getFirstData(null, 0);
            this.clearData();
            this.sendGoIssues();
        });
        //号码改变
        this.events.subscribe('issues:change', () => {
            this.getFirstData(null, 0, true);
        });
        //跳转到追号界面
        this.events.subscribe('issues:goPage', () => {
            console.log('issues:goPage ', 1);

            // if (LotteryPage.betMoney == 0) {

            //     setTimeout(() => {
            //         AppDialog.toast({
            //             toastCtrl: this.toastCtrl,
            //             message: "Vui lòng thêm nội dụng cược."
            //         });
            //     }, 500);
            // }

            let lastToastTime = 0;  // Variable to track the last toast time

            if (LotteryPage.betMoney == 0 ) {
                const currentTime = new Date().getTime();

                // Check if the last toast was shown more than 1 second ago
                if (currentTime - lastToastTime > 1000) {
                    lastToastTime = currentTime;  // Update the last toast time

                    setTimeout(() => {
                        AppDialog.toast({
                            toastCtrl: this.toastCtrl,
                            message: this.translate.instant('GO_PERIODS_PAGE.ADD_BET_CONTENT')
                        });
                    }, 500);
                }
            }


            this.goMoney = LotteryPage.betMoney;
            //this.goTraceTime = LotteryPage.betTraceTime;
            this.goTraceTime = 1;
            this.isGo = true;
            this.getFirstData();
        });
    }

    /**
     * 下拉刷新清空所有
     * @param refresher
     */
    doRefresh(refresher) {
        this.getFirstData(refresher, 0);
        this.clearData();
        this.sendGoIssues();
    }

    winningStopChanged() {
        this.sendGoIssues();
    }

    selectIssues(id: number) {
        let issue = this.recordList[id];
        let isSelect = !issue.isSelect;
        this.recordList[id].isSelect = isSelect;
        if (isSelect) {
            this.totalMoney = this.decimalAdd(this.totalMoney, issue.money);
            this.traceIssues.set(issue.issue, this.recordList[id]);
        } else {
            this.totalMoney = this.decimalSub(this.totalMoney, issue.money);
            this.traceIssues.delete(issue.issue);
        }
        console.log('this.traceIssues', this.traceIssues);

        this.totalNum = this.traceIssues.size;

        this.sendGoIssues();
    }

    decimalAdd(a: number, b: number) {
        return Math.round(a * 1000 + b * 1000) / 1000;
    }

    decimalSub(a: number, b: number) {
        return Math.round(a * 1000 - b * 1000) / 1000;
    }

    /**
     *
     * @param refresher 刷新参数
     * @param i  多少个被勾选
     * @param change 是否更换期数
     */
    getFirstData(refresher: any = null, i: number = 1, change: boolean = false) {
        if (!this.isGo) {
            return;
        }
        this.totalMoney = 0;
        this.totalNum = 0;
        let dataParams = {
            lotteryid: LotteryPage.lotteryId
        };
        this.lotteryService.lotteryTraceList(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                let oldSave = [];
                let issueList = data["issuelist"].slice(0, 50);
                issueList.map((item, index) => {
                    item["money"] = this.goMoney;
                    item["num"] = this.goTraceTime;
                    item["isSelect"] = false;
                    if (this.traceIssues.has(item.issue)) {
                        item = this.traceIssues.get(item.issue);
                        oldSave.push(index);
                    }
                    return item;
                });
                // this.recordList = data["issuelist"];
                this.recordList = issueList;
                if (change) {
                    this.traceIssues.clear();
                    oldSave.forEach((item) => {
                        this.selectIssues(item);
                    });
                } else {
                    while (i--) {
                        this.selectIssues(i);
                    }
                    if (refresher) {
                        refresher.complete();
                    }
                }
            }
        });
    }

    ionViewWillLeave() {
        this.clearData();
        this.isGo = false;
        this.sendGoIssues();
    }

    clearData() {
        this.totalMoney = 0;
        this.totalNum = 0;
        this.traceIssues.clear();
    }

    addMoney(index: number) {
        let issue = this.recordList[index];
        issue.num++;
        issue.money = this.decimalAdd(issue.money, this.goMoney);
        if (issue.isSelect) {
            this.totalMoney = this.decimalAdd(this.totalMoney, this.goMoney);
        }
        this.recordList[index] = issue;
        this.sendGoIssues();
    }

    reduceMoney(index: number) {
        let issue = this.recordList[index];
        if (issue.num - 1 > 0) {
            issue.num--;
            issue.money = this.decimalSub(issue.money, this.goMoney);
            if (issue.isSelect) {
                this.totalMoney = this.decimalSub(this.totalMoney, this.goMoney);
            }
        }
        this.recordList[index] = issue;
        this.sendGoIssues();
    }

    onNumChange(index: number, num: number) {
        let issue = this.recordList[index];
        this.totalMoney = this.decimalSub(this.totalMoney, issue.money);
        issue.num = Math.floor(num);
        issue.money = (this.goMoney / this.goTraceTime) * issue.num;
        if (issue.isSelect) {
            this.totalMoney = this.decimalAdd(this.totalMoney, issue.money);
        }
        this.recordList[index] = issue;
        this.sendGoIssues();
    }

    sendGoIssues() {
        this.events.publish('issues:go', {
            isGo: this.isGo,
            goStop: this.goStop,
            totalMoney: this.totalMoney,
            totalNum: this.totalNum,
            traceIssues: this.traceIssues
        });
    }

    dismiss() {
        this.viewCtrl.getNav().parent.parent.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/goPeriods/goPeriods.ts